var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap" }, [
      _c("header", { staticClass: "header header--protein" }, [
        _c("div", { staticClass: "header__container" }, [
          _c("div", { staticClass: "header__row" }, [
            _c("a", {
              staticClass: "prev prev--white",
              attrs: { href: "/myprotein-result", "aria-label": "이전" }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "title" }, [
            _vm._v("\n\t\t\t\t\t나이가 들수록 감소하는 체내"),
            _c("br"),
            _vm._v("\n\t\t\t\t\t‘단백질양’\n\t\t\t\t")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents" }, [
        _c(
          "div",
          { staticClass: "contents__contents contents__contents--overlap" },
          [
            _c("p", { staticClass: "desc desc--secondary" }, [
              _vm._v(
                "\n\t\t\t\t\t체내 단백질은 나이가 들어감에 따라 자연스럽게 감소하여 65세 이상 노인의 경우 20대에 비해\n\t\t\t\t\t"
              ),
              _c("span", { staticClass: "line-highlight" }, [
                _vm._v("총 신체 단백질이 약 14% 감소합니다.")
              ]),
              _vm._v(" "),
              _c("br"),
              _c("br"),
              _vm._v(
                "\n\t\t\t\t\t건강한 삶을 원한다면 연령에 상관없이 매일매일 꾸준히 단백질을 섭취해야 하는 이유입니다.\n\t\t\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "img" }, [
              _c("img", {
                attrs: {
                  src: require("./assets/images/protein03.png"),
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "etc" }, [
              _vm._v(
                "*출처: Hardman, Shalene E. The Effects of Aging on Skeletal Muscle AMPK Activation and an Analysis of Chronic AICAR Treatment on the Aging Phenotype. Diss. Brigham Young University, 2014."
              )
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa52628a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa52628a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinInfo03.vue
// module id = LQEi
// module chunks = 0